export class Asset {
  constructor(public readonly path: string, public readonly file: File) {}
}
